import { render, staticRenderFns } from "./UpdatePinForm.vue?vue&type=template&id=68be4ad2"
import script from "./UpdatePinForm.vue?vue&type=script&lang=ts"
export * from "./UpdatePinForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports